// extracted by mini-css-extract-plugin
export default {"root":"SessionDiagram_root__Q4M10","svg":"SessionDiagram_svg__2rYK+","hide":"SessionDiagram_hide__CQP44","board":"SessionDiagram_board__CKCo4"};